import { render, staticRenderFns } from "./CountriesGrid.vue?vue&type=template&id=1be1f7a6&"
import script from "./CountriesGrid.vue?vue&type=script&lang=js&"
export * from "./CountriesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports